import { render, staticRenderFns } from "./TabFacebook.vue?vue&type=template&id=5fb242b8&scoped=true"
import script from "./TabFacebook.vue?vue&type=script&lang=ts"
export * from "./TabFacebook.vue?vue&type=script&lang=ts"
import style0 from "./TabFacebook.vue?vue&type=style&index=0&id=5fb242b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb242b8",
  null
  
)

export default component.exports